import { useEffect, useState } from "react";

export default function Countdown({ dealEnd }) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!dealEnd) return null;
  const diff = Math.max(0, new Date(dealEnd).getTime() - now);
  const cells = [
    ["DAYS", Math.floor(diff / 864e5)],
    ["HRS", Math.floor(diff / 36e5) % 24],
    ["MIN", Math.floor(diff / 6e4) % 60],
    ["SEC", Math.floor(diff / 1e3) % 60],
  ];

  return (
    <div data-testid="countdown-timer" className="flex gap-2">
      {cells.map(([label, val]) => (
        <div
          key={label}
          className="border border-[#262626] bg-[#121212] px-3 py-2 text-center min-w-[64px]"
        >
          <div className="font-display text-2xl leading-none text-white">
            {String(val).padStart(2, "0")}
          </div>
          <div className="font-mono text-[10px] tracking-[0.2em] text-[#888] mt-1">{label}</div>
        </div>
      ))}
    </div>
  );
}
